// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-8980c666] .el-table__row {\n  font-weight: bold;\n}\n#mapIframe[data-v-8980c666] {\n  width: 100%;\n  height: 70vh;\n}\n.error-message[data-v-8980c666] {\n  color: red;\n  padding: 20px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
